<template>
  <div>
    <SummaryWidget
      v-model="cumulativeReport"
      :cumulativeReport="cumulativeReport"
      :dailyReport="dailyReport"
      :targetNational="nationalTarget"
    />
    <div class="subheader py-3 py-lg-3 subheader-transparent transparent">
      <div
        class="
          d-flex
          align-items-center
          justify-content-between
          flex-wrap flex-sm-nowrap
          container-fluid
          p-0
        "
      >
        <div class="d-flex align-items-baseline mr-5 mb-5">
          <h3 class="subheader-title text-dark font-weight-bold my-2 mr-3">
            Tracking laporan vaksinasi
          </h3>
        </div>
        <div class="d-flex align-items-center">
          <span class="text-muted">
            (Klik tombol ini untuk melihat peta provinsi)
          </span>
          <Toggle
            class="ml-3"
            v-model="isDistrict"
            on-label="KaKo"
            off-label="Provinsi"
            :width="100"
            :height="30"
            :speed="500"
            :colors="{
              background: {
                on: '#FFA800',
                off: '#1bc5bd',
              },
              text: {
                on: '#ffffff',
                off: '#ffffff',
              },
            }"
            @change="updateRegionToggle()"
          />
        </div>
      </div>
    </div>
    <!-- trigger to show offcanvas -->
    <a
      v-if="!isDistrict"
      href="#"
      class="position-relative d-none"
      id="kt_quick_search_toggle"
      ref="clickme"
    >
      click me!
    </a>
    <KTQuickSearch v-if="!isDistrict" :summaryData="summaryData" />

    <b-alert show dismissible fade variant="success" v-if="!isDistrict">
      <div class="alert-text">
        Klik
        <b>peta provinsi</b>
        untuk melihat detil info
      </div>
    </b-alert>
    <div class="card card-custom card-stretch gutter-b mb-0 pb-5">
      <!--begin::Header-->
      <div class="card-header border-0 py-1 pr-4 pl-4 pt-3">
        <div class="card-title font-weight-bolder">
          <div class="card-label text-white">
            Laporan vaksinasi {{ selectedToggle }}
            <div class="text-white font-size-lg mt-2">Visualisasi data</div>
          </div>
        </div>
        <div class="card-toolbar">
          <toggle-switch
            :options="switchOptions"
            :value="selectedToggle"
            @change="updateToggle($event.value)"
            class="mt-2"
          />
        </div>
      </div>
      <!--end::Header-->
      <!--begin::Body-->
      <div class="card-body pr-0 pl-0 pt-0 pb-0">
        <div
          v-if="isLoading"
          class="
            p-10
            d-flex
            align-items-center
            justify-content-center
            loading-indicator
          "
        >
          <Spinner line-bg-color="#ddd" text-fg-color="#007bff" />
        </div>
        <template v-if="!isLoading">
          <!--begin::Map Container-->
          <MapContainer
            :titleKey="titleKey"
            :idKey="idKey"
            :geojsonIdKey="geojsonIdKey"
            :title="title"
            :reportData="reportData"
            :geojson="geojson"
            :dose="selectedToggle"
            @map-on-click="mapOnClick"
            :denom="denomData"
            :isDistrict="isDistrict"
          />
          <!--end::Map Container-->
        </template>
      </div>
      <!--end::Body-->
    </div>
    <!-- hack to call target reactivity -->
    {{ callSubNationalTarget }}
    <Chart />
    <!-- <pre class="language-json"><code>{{ getDoseThreeProvince }}</code></pre> -->
  </div>
</template>

<script>
// sampel https://github.com/voluntadpear/vue-choropleth
import { mapGetters, mapState } from 'vuex'
import axios from 'axios'
import store from '@/core/services/store'
import { FETCH_TARGET } from '@/core/services/store/target.module'
import { FETCH_VACCINE_REPORT } from '@/core/services/store/vaccinesreport.module'
import { FETCH_GEOJSON } from '@/core/services/store/map.module'
const MapContainer = () => import('@/view/pages/home/map/MapContainer.vue')
import SummaryWidget from '@/view/pages/home/SummaryWidget'
// for switch region
import Toggle from '@vueform/toggle/dist/toggle.vue2.js'
// for dose
import ToggleSwitch from 'vuejs-toggle-switch'
import Spinner from 'vue-simple-spinner'
import { today } from '@/core/helpers/temp/util.js'

import Chart from '@/view/pages/home/Chart.vue'

// offcanvas
import KTQuickSearch from '@/view/pages/home/QuickSearch'

export default {
  name: 'home',
  data: function () {
    return {
      geojson: null,
      isGeojsonReady: false,
      // toggle
      selectedToggle: 'Dosis 1',
      switchOptions: {
        layout: {
          color: '#3699ff',
          backgroundColor: 'white',
          selectedColor: 'white',
          selectedBackgroundColor: 'green',
          borderColor: '#3699ff',
          fontFamily: 'Arial',
          fontWeight: 'normal',
          fontWeightSelected: 'normal',
          squareCorners: false,
          noBorder: false,
        },
        size: {
          fontSize: 1,
          height: 2.5,
          width: 15,
        },
        items: {
          delay: 0.4,
          preSelected: 'unknown',
          disabled: false,
          labels: [
            { name: 'Dosis 1', color: 'white', backgroundColor: '#3699ff' },
            {
              name: 'Dosis 2',
              color: 'white',
              backgroundColor: '#3699ff',
            },
            {
              name: 'Dosis 3',
              color: 'white',
              backgroundColor: '#3699ff',
            },
          ],
        },
      },
      cumulativeReport: null,
      // by district
      dailyReport: null,
      // region switch
      isDistrict: true,
      // province profile
      summaryData: null,

      denomData: [],
    }
  },
  components: {
    MapContainer,
    ToggleSwitch, // toggle
    Spinner,
    SummaryWidget,
    Toggle,

    // offcanvas
    KTQuickSearch,
    Chart,
  },
  async mounted() {
    await this.fetchData()
  },
  watch: {
    $route: 'fetchData',
  },
  methods: {
    fetchData() {
      // get vaccines target
      store.dispatch(FETCH_TARGET)
      // get vaccines data
      store.dispatch(FETCH_VACCINE_REPORT)
      // get geojson
      this.loadGeojsonData()

      // get cumulative data
      const apiUrl = process.env.VUE_APP_SERVICE_URL
      axios
        .get(`${apiUrl}/api/cluster_immunization/cumulative_report`)
        .then((res) => {
          // console.log(res)
          this.cumulativeReport = Object.freeze(res.data)
        })
        .catch((err) => {
          console.log(err)
        })

      // get daily report by district
      axios
        .get(`${apiUrl}/api/cluster_immunization/vaccine_report`, {
          params: {
            date: today(),
          },
        })
        .then((res) => {
          // console.log(res)
          this.dailyReport = Object.freeze(res.data.data)
        })
        .catch((err) => {
          console.log(err)
        })
    },

    loadGeojsonData: function () {
      // const label = this.isDistrict ? 'DISTRICT' : 'IDN'
      const label = this.isDistrict ? 'DISTRICT_humdata' : 'IDN'
      const baseUrl = process.env.VUE_APP_BASE_URL

      if (!this.map[label]) {
        axios
          .get(`${baseUrl}/media/map/${label}.json`)
          .then((res) => {
            this.geojson = Object.freeze(res.data)
            this.isGeojsonReady = true
            store.dispatch(FETCH_GEOJSON)
          })
          .catch((err) => {
            console.log(err)
          })
      } else {
        // console.log('fathian')
        this.geojson = this.map[label]
        this.isGeojsonReady = true
      }
    },

    // toggle for switch region
    updateRegionToggle() {
      this.loadGeojsonData()
    },

    // toggle for dose
    updateToggle($event) {
      this.selectedToggle = $event
    },
    mapOnClick() {
      if (this.regionId.length === 2) {
        const apiUrl = process.env.VUE_APP_SERVICE_URL
        axios
          .get(
            `${apiUrl}/api/cluster_immunization/vc19_cumulative?id=${this.regionId}`
          )
          .then((res) => {
            console.log(res.data)
            this.summaryData = Object.freeze(res.data[0])

            this.$refs.clickme.click()
          })
          .catch((err) => {
            console.log(err)
          })
      }
    },

    // manipulate target data
    subNationalTarget(array) {
      const finalData = array.map((item) => {
        // TOTAL TARGET
        let total = 0
        switch (this.selectedToggle) {
          // hack dosis 3 sasaran adalah diatas 18th
          case 'Dosis 3':
            total =
              item.total - item.sasaran_usia_6_11 - item.sasaran_usia_12_17
            break
          default:
            total =
              this.getTargetType == 'Dengan Anak'
                ? item.total
                : item.total_tanpa_anak
        }

        const container = {}
        container.id_kabupaten = item.id_kabupaten
        container.nama_kabupaten = item.nama_kabupaten
        container.id_provinsi = item.id_provinsi
        container.nama_provinsi = item.nama_provinsi
        container.sasaran_usia_12_17 = item.sasaran_usia_12_17
        container.sasaran_usia_6_11 = item.sasaran_usia_6_11
        container.sdmkes = item.sdmkes
        container.pet_pub = item.pet_pub
        container.lansia = item.lansia
        container.tahap_3 = item.tahap_3
        container.total = total

        return container
      })
      this.denomData = finalData
    },

    updateSubNationalTarget(array) {
      array.map((item, index) => {
        // TOTAL TARGET
        let total = 0
        switch (this.selectedToggle) {
          // hack dosis 3 sasaran adalah diatas 18th
          case 'Dosis 3':
            total =
              item.total - item.sasaran_usia_6_11 - item.sasaran_usia_12_17
            break
          default:
            total =
              this.getTargetType == 'Dengan Anak'
                ? item.total
                : item.total_tanpa_anak
        }

        const container = {}
        container.id_kabupaten = item.id_kabupaten
        container.nama_kabupaten = item.nama_kabupaten
        container.id_provinsi = item.id_provinsi
        container.nama_provinsi = item.nama_provinsi
        container.sasaran_usia_12_17 = item.sasaran_usia_12_17
        container.sasaran_usia_6_11 = item.sasaran_usia_6_11
        container.sdmkes = item.sdmkes
        container.pet_pub = item.pet_pub
        container.lansia = item.lansia
        container.tahap_3 = item.tahap_3
        container.total = total

        // hack for array reactivity
        this.$set(this.denomData, index, container)
      })
    },
  },
  computed: {
    ...mapGetters([
      'getDoseOneDistrict',
      'getDoseTwoDistrict',
      'getDoseThreeDistrict',
      'getDoseOneProvince',
      'getDoseTwoProvince',
      'getDoseThreeProvince',
      'getRegionId',
      'getTargetType',
      'getNationalTarget',
      'getProvinceTarget',
      'getDistrictTarget',
    ]),
    ...mapState(['vaccinesreport', 'map', 'target']),
    isLoading() {
      return this.isGeojsonReady && this.reportData ? false : true
    },

    // ALL FOR MAPS
    // reportData: map data
    reportData() {
      if (this.vaccinesreport.isReady) {
        let data
        switch (this.selectedToggle) {
          case 'Dosis 1':
            data = this.isDistrict
              ? this.getDoseOneDistrict
              : this.getDoseOneProvince
            break
          case 'Dosis 2':
            data = this.isDistrict
              ? this.getDoseTwoDistrict
              : this.getDoseTwoProvince
            break
          default:
            data = this.isDistrict
              ? this.getDoseThreeDistrict
              : this.getDoseThreeProvince
        }

        return data
      }
      return false
    },
    titleKey() {
      return this.isDistrict ? 'kabupaten' : 'provinsi'
    },
    idKey() {
      return this.isDistrict ? 'id_kabupaten' : 'id_provinsi'
    },
    geojsonIdKey() {
      return this.isDistrict ? 'ADM2_PCODE' : 'CC_2'
    },
    title() {
      return this.isDistrict ? 'Kabupaten/Kota' : 'Provinsi'
    },
    regionId() {
      return this.getRegionId
    },

    // TARGET
    nationalTarget() {
      if (this.getNationalTarget) {
        return this.getTargetType == 'Dengan Anak'
          ? this.getNationalTarget['total']
          : this.getNationalTarget['total_tanpa_anak']
      }

      return 0
    },

    callSubNationalTarget() {
      if (this.target.isReady) {
        const arrayData = this.isDistrict
          ? this.getDistrictTarget
          : this.getProvinceTarget

        if (this.denomData.length === 0) {
          return this.subNationalTarget(arrayData)
        }

        return this.updateSubNationalTarget(arrayData)
      }
      return null
    },
  },
}
</script>

<style src="@vueform/toggle/themes/default.css"></style>
<style lang="scss" scoped>
.loading-indicator {
  min-height: 550px;
}
.card-custom {
  background-color: #75cff0;
}
</style>
